import { Component, EventEmitter, Output } from "@angular/core";
import { DeckLayerName } from "@apiserver-rest/ponder-data-client";
import { Deck, DeckCard, GameType } from "@apiserver-rest/ponder-data-client-base";

@Component({
    template: "",
    standalone: false
})
export class DeckEvents {
    @Output()
    public cardMoveToLayerEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public deckBackgroundUpdatedEvent: EventEmitter<Deck> = new EventEmitter();

    @Output()
    public deckDeletedEvent: EventEmitter<string> = new EventEmitter();

    @Output()
    public displaySwitchCardVersionEvent: EventEmitter<DeckCard | undefined> = new EventEmitter();

    @Output()
    public displayAddAlternateCardVersionEvent: EventEmitter<DeckCard | undefined> = new EventEmitter();

    @Output()
    public onCardVersionSwitchedEvent: EventEmitter<DeckCard | undefined> = new EventEmitter();

    @Output() 
    public deckCardEvent: EventEmitter<DeckCardEvent> = new EventEmitter();

    @Output()
    public deckChangeGroupEvent: EventEmitter<DeckChangeGroupEvent> = new EventEmitter();

    @Output()
    public showAddCardToDecksModalEvent: EventEmitter<ShowAddCardToDecksModalEvent> = new EventEmitter();

    @Output()
    public indirectDeckCardUpdatedEvent: EventEmitter<IndirectDeckCardUpdatedEvent> = new EventEmitter();

    @Output()
    public showDeckCreateModalEvent: EventEmitter<any> = new EventEmitter();

    @Output()
    public showDeckImportModalEvent: EventEmitter<any> = new EventEmitter();
}

export class CardMoveToLayerEvent {
    public deckCard!: DeckCard;
    public fromLayer!: DeckLayerName;
    public toLayer!: DeckLayerName;
}

export class DeckCardEvent {
    public deckCard!: DeckCard;

    public prevCount!: number;
    public currCount!: number;
    public countChange!: number;

    public prevSpecialCount!: number;
    public currSpecialCount!: number;
    public specialCountChange!: number;

    public layer!: DeckLayerName;
}

export class DeckChangeGroupEvent {
    public deck!: Deck;
    public fromGroup!: string;
    public toGroup!: string;
}

export class ShowAddCardToDecksModalEvent {
    public game!: GameType;
    public name!: string;
    public itemId!: string;
    public hasNormal!: boolean;
    public hasSpecial!: boolean;
}

export class IndirectDeckCardUpdatedEvent {
    public deckId!: string;
    public deckName!: string;
    public deckColor!: string;
    public backgroundCardId?: string;
    public layer!: string;
    public itemId!: string;
    public count!: number;
    public specialCount!: number;
}